module.exports = __webpack_public_path__ + "medipack_blisterfinder.umd.min.0.worker.js"